import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/labelTemplates'
import Component from 'components/LabelTemplates'

export default createListViewContainer({ actions, selectors: selectors.labelTemplates })(Component)
